import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LeadCaptureWidgetSubmission } from '../interfaces/lead-capture-submission.interface';
import { BookingResponse } from '../interfaces/tour-booking.interface';
import { WidgetRecaptchaSubmitPayload } from './recaptcha/widget-recaptcha.types';
import { FormSubmissionService } from './form-submission.service';

@Injectable({
  providedIn: 'root',
})
export class TrialBookingService {
  private readonly formSubmissionService = inject(FormSubmissionService);

  submitTrialBooking(
    widgetId: string,
    payload: LeadCaptureWidgetSubmission,
    captcha?: WidgetRecaptchaSubmitPayload,
  ): Observable<BookingResponse> {
    if (!widgetId) {
      throw new Error('Widget ID is required for trial booking');
    }

    return this.formSubmissionService.submitTrialBookingLeadCapture(
      widgetId,
      payload,
      captcha,
    );
  }
}
